"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.keywordSearchOptions = void 0;
var isStringMatch_1 = require("../../../../utils/isStringMatch");
var getValue_1 = require("./getValue");
var keywordSearchOptions = function (_a) {
    var options = _a.options, searchString = _a.searchString, searchFieldsConfig = _a.searchFieldsConfig, setFilteredOptionsInParent = _a.setFilteredOptionsInParent;
    // If any options are loading, return the original options
    if (options.some(function (d) { return d.loading === true; }))
        return options;
    // Check if we're dealing with grouped data
    var isGrouped = (0, getValue_1.isGroupedData)(options);
    if (isGrouped) {
        // Handle grouped data
        var filteredGroups = options.map(function (group) {
            // Filter the options within each group
            var filteredOptions = group.options.filter(function (option) {
                return (0, isStringMatch_1.isStringMatch)({
                    data: option,
                    toMatchPath: searchFieldsConfig || 'display',
                    subString: searchString
                });
            });
            // Return a new group object with filtered options
            return __assign(__assign({}, group), { options: filteredOptions });
        }).filter(function (group) { return group.options.length > 0; }); // Only keep groups that have matching options
        // Track filtered options if needed
        if (setFilteredOptionsInParent && searchString) {
            // Flatten all options from all groups for tracking
            var allFilteredOptions = filteredGroups.flatMap(function (group) { return group.options; });
            setFilteredOptionsInParent(allFilteredOptions);
        }
        return filteredGroups;
    }
    else {
        // Handle normal data (original logic)
        var filteredOptions = options.filter(function (option) {
            return (0, isStringMatch_1.isStringMatch)({
                data: option,
                toMatchPath: searchFieldsConfig || 'display',
                subString: searchString
            });
        });
        // Track filtered options if needed
        if (setFilteredOptionsInParent && searchString) {
            setFilteredOptionsInParent(filteredOptions);
        }
        return filteredOptions;
    }
};
exports.keywordSearchOptions = keywordSearchOptions;
